import { fork } from 'redux-saga/effects'
import { teamRolesSaga } from './teamRoles'
import { teamMemberInvitesSaga } from './teamMemberInvites'
import { teamMembersSaga } from './teamMembers'

export function* teamSaga() {
  yield fork(teamRolesSaga)
  yield fork(teamMembersSaga)
  yield fork(teamMemberInvitesSaga)
}
